import { ToastsStore } from 'react-toasts';

const Toaster = {
	showSuccess: (message) => {
		ToastsStore.success(message)
	},
	showInfo: (message) => {
		ToastsStore.info(message)
	},
	showError: (message) => {
		ToastsStore.error(message)
	},
	showWarning: (message) => {
		ToastsStore.warning(message)
	}
}
export default Toaster